import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

/**
 * Load the latest published version of a single company configuration.
 * The query is disabled until a `configCode` is provided (create flow).
 */
export function useCompanyConfigOverview(configCode: string | undefined) {
  return useQuery({
    queryKey: ["companyConfig", configCode],
    queryFn: () => api.getCompanyConfigOverview(configCode as string),
    enabled: Boolean(configCode),
  });
}
